<template>
	<div>
		<v-layout>
			<v-flex xs12>
				<v-app-bar class="py-1" color="#00807a" fixed height="95">
					<v-flex md9 xs6>
						<v-img
							class="menu_links"
							src="../assets/sharpsmart.png"
							width="100px"
							alt="Home"
							@click="openLink()"
						>
						</v-img>
					</v-flex>
					<v-row justify="center">
						<v-flex md1 xs4>
							<v-btn
								large
								depressed
								v-if="$route.name === 'dashboard'"
								color="teal white--text"
								@click="logout()"
							>
								<span>Logout</span>
							</v-btn>
						</v-flex>
					</v-row>
				</v-app-bar>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import "firebase/auth";
import firebase from "firebase/app";
export default {
	data() {
		return {
			drawer: false,
		};
	},
	methods: {
		openLink() {
			window.open("https://sharpsmart.co.uk");
		},

		logout() {
			if (firebase.auth().currentUser) {
				firebase.auth().signOut();
				this.$router.push({ name: "login" });
			}
		},
	},
};
</script>

<style>
.menu_links {
	cursor: pointer;
}
</style>
